import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.use(FloatingVue, {
    themes: {
      tooltip: {
        // Increase hide delay to prevent stuck tooltips
        delay: {
          show: 200,
          hide: 100,
        },
        // Handle content updates more gracefully
        handleResize: true,
        // Ensure tooltip hides on mouseleave
        hideTriggers: events => [...events, 'click'],
        // Allow the tooltip to stay open when hovering over it
        popperTriggers: [],
        // Auto-hide when clicking outside
        autoHide: true,
        // Instantly move to new position when content changes
        instantMove: true,
        // Dispose timeout to clean up DOM
        disposeTimeout: 150,
      },
    },
  });
});
